import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DynamicFormServices } from '../../dynamic-form/services/dynamic-form.services';
import { ApplicationService } from 'src/app/services/application.service';
import { MyUtils } from 'src/app/services/my-utils.service';
import { InterviewsService } from 'src/app/services/interviews.service';
import { ObjectFrom } from '../../dynamic-form/models/input-form';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-tag-online-rep-dialog',
  templateUrl: './tag-online-rep-dialog.component.html',
  styleUrls: ['./tag-online-rep-dialog.component.scss']
})
export class TagOnlineRepDialogComponent implements OnInit {

  inputForm: ObjectFrom[];
  formGroup: FormGroup;
  multiresponse: string[] = ["Sales" , "AfterSales","Shopper"];

  constructor(
    private dynamicFormService: DynamicFormServices,
    public utils: MyUtils,
    private applicationService: ApplicationService,
    private interviewService: InterviewsService,
    private dialogRef: MatDialogRef<TagOnlineRepDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tag: string,
      section?:string;
    }) {
      //console.log(data.section)
    this.inputForm = [
      [
        {
          formControlName: "Tag",
          label: "Choose a new Tag",
          placeholder: "Choose a new Tag",
          value: '',
          validators: {
            required: true,
          },
          objectSelect: this.multiresponse,
          template: "select",
          className: "custom-border",
          disabled: false,
        },
      ]
    ],
    this.formGroup = this.dynamicFormService.generateFormGroup(this.inputForm);
  }

  ngOnInit(): void {
  }

  onSave(){
    this.data.tag = this.formGroup.get('Tag')?.value
    delete this.data.section;
    this.dialogRef.close(this.data)
  }

  onDelete(){
    this.data.section = "";
    this.onSave();
  }

}
